module.exports = __webpack_public_path__ + "img/logo-up-new-12.a0273775.png";